var React = require('react');

function IconIssues (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M7.333 11v3.667h7.334V11h5.5V9.167H1.833V11h5.5zM5.5 12.833H1.833v5.5c0 1.013.821 1.834 1.834 1.834h14.666c1.013 0 1.834-.821 1.834-1.834v-5.5H16.5v1.834c0 1.012-.82 1.833-1.833 1.833H7.333A1.833 1.833 0 0 1 5.5 14.667v-1.834zM1.833 5.5v1.833h18.334V5.5H1.833zm0-1.833h18.334c0-1.013-.821-1.834-1.834-1.834H3.667c-1.013 0-1.834.821-1.834 1.834zM3.667 0h14.666A3.667 3.667 0 0 1 22 3.667v14.666A3.667 3.667 0 0 1 18.333 22H3.667A3.667 3.667 0 0 1 0 18.333V3.667A3.667 3.667 0 0 1 3.667 0z","fill":"currentColor","fillRule":"nonzero"}));
}

IconIssues.defaultProps = {"width":"22","height":"22"};

module.exports = IconIssues;

IconIssues.default = IconIssues;
